import React from 'react'
import PropTypes from 'prop-types'

const DynamicPagesHandler = ({ activeStep, steps }) => {
    return <div>{steps[activeStep].page}</div>
}

DynamicPagesHandler.propTypes = {
    activeStep: PropTypes.number,
    steps: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
}

export { DynamicPagesHandler }
